import { Array, Effect, pipe } from "effect";
import { GraphClient } from "../graph-client";
import {
  ProdProtocolKey,
  ProdProtocolKeyService,
  ProtocolKeyService,
  ProtocolStateService,
} from "@silo/types";
import { getProtocolState } from "../protocol/get-protocol-state";
import { getPrimaryDisplayMarket } from "./get-primary-display-market";
import { getProtocolConfig } from "@silo/config";

export type GetPrimaryProtocolMarkets = ReturnType<
  typeof getPrimaryProtocolMarkets
>;
export type GetPrimaryProtocolMarketsSuccess =
  Effect.Effect.Success<GetPrimaryProtocolMarkets>;
export type GetPrimaryProtocolMarketsError =
  Effect.Effect.Error<GetPrimaryProtocolMarkets>;
export type GetPrimaryProtocolMarketsContext =
  Effect.Effect.Context<GetPrimaryProtocolMarkets>;

export function getPrimaryProtocolMarkets(prodProtocolKey: ProdProtocolKey) {
  return Effect.gen(function* () {
    const [graphMarkets, protocolState] = yield* Effect.all(
      [GraphClient.getGraphMarkets(), getProtocolState()],
      { concurrency: "unbounded" }
    );

    const protocolConfig = getProtocolConfig(prodProtocolKey);

    const displayGraphMarkets = pipe(
      graphMarkets,
      Array.filter((market) =>
        protocolConfig.marketWhitelist.has(market.marketAddress)
      )
    );

    const displayMarketArray = yield* pipe(
      Effect.all(
        displayGraphMarkets.map((graphMarket) =>
          getPrimaryDisplayMarket(graphMarket)
        ),
        { concurrency: "unbounded" }
      ),
      Effect.provideService(ProtocolStateService, protocolState)
    );

    yield* Effect.log(
      `Complete ✅: get ${prodProtocolKey} markets with graph strategy`
    );

    return displayMarketArray;
  }).pipe(
    Effect.provideService(ProdProtocolKeyService, prodProtocolKey),
    Effect.provideService(ProtocolKeyService, prodProtocolKey)
  );
}
